"use strict";

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(typeof e + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GivenchyPhotoboothCell;
var _react = _interopRequireWildcard(require("react"));
var _qrcode = require("qrcode.react");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function GivenchyPhotoboothCell(_ref6) {
  var cell = _ref6.cell,
    screenType = _ref6.screenType,
    language = _ref6.language,
    project = _ref6.project,
    logEvent = _ref6.logEvent,
    page = _ref6.page,
    intl = _ref6.intl,
    uriTransformer = _ref6.uriTransformer;
  var _ref7 = (0, _react.useState)(false),
    _ref8 = _slicedToArray(_ref7, 2),
    isInitialized = _ref8[0],
    setIsInitialized = _ref8[1];
  var _ref9 = (0, _react.useState)(null),
    _ref0 = _slicedToArray(_ref9, 2),
    error = _ref0[0],
    setError = _ref0[1];
  var _ref1 = (0, _react.useState)(true),
    _ref10 = _slicedToArray(_ref1, 2),
    loading = _ref10[0],
    setLoading = _ref10[1];
  var videoRef = (0, _react.useRef)(null);
  var _ref11 = (0, _react.useState)(4),
    _ref12 = _slicedToArray(_ref11, 2),
    count = _ref12[0],
    setCount = _ref12[1]; // 4 photos pour Givenchy
  var _ref13 = (0, _react.useState)([]),
    _ref14 = _slicedToArray(_ref13, 2),
    photos = _ref14[0],
    setPhotos = _ref14[1]; // Array to store the photos taken
  var _ref15 = (0, _react.useState)({
      index: 0,
      photoUri: null
    }),
    _ref16 = _slicedToArray(_ref15, 2),
    currentPhoto = _ref16[0],
    setCurrentPhoto = _ref16[1]; // Current photo being captured
  var _ref17 = (0, _react.useState)(0),
    _ref18 = _slicedToArray(_ref17, 2),
    step = _ref18[0],
    setStep = _ref18[1]; // Step to track the current state of the photobooth
  var _ref19 = (0, _react.useState)(false),
    _ref20 = _slicedToArray(_ref19, 2),
    printed = _ref20[0],
    setPrinted = _ref20[1]; // Track if the photo has been printed
  var _ref21 = (0, _react.useState)(''),
    _ref22 = _slicedToArray(_ref21, 2),
    email = _ref22[0],
    setEmail = _ref22[1]; // Email input for sending the photo
  var _ref23 = (0, _react.useState)(''),
    _ref24 = _slicedToArray(_ref23, 2),
    link = _ref24[0],
    setLink = _ref24[1]; // Link for QR code generation
  var _ref25 = (0, _react.useState)(false),
    _ref26 = _slicedToArray(_ref25, 2),
    isSending = _ref26[0],
    setIsSending = _ref26[1]; // Track if the photo is being sent
  var _ref27 = (0, _react.useState)(false),
    _ref28 = _slicedToArray(_ref27, 2),
    started = _ref28[0],
    setStarted = _ref28[1]; // Track if the photo has been sent
  var _ref29 = (0, _react.useState)(false),
    _ref30 = _slicedToArray(_ref29, 2),
    emailSended = _ref30[0],
    setEmailSended = _ref30[1]; // Track if the email has been sent
  var _ref31 = (0, _react.useState)(null),
    _ref32 = _slicedToArray(_ref31, 2),
    currentDataUri = _ref32[0],
    setCurrentDataUri = _ref32[1]; // Current data URI of the photo being captured
  var _ref33 = (0, _react.useState)(0),
    _ref34 = _slicedToArray(_ref33, 2),
    progress = _ref34[0],
    setProgress = _ref34[1]; // Progress of the GIF creation
  var _ref35 = (0, _react.useState)(false),
    _ref36 = _slicedToArray(_ref35, 2),
    isSelected = _ref36[0],
    setIsSelected = _ref36[1]; // Track if the cell is selected
  var _ref37 = (0, _react.useState)(null),
    _ref38 = _slicedToArray(_ref37, 2),
    blops = _ref38[0],
    setBlops = _ref38[1]; // Array to store the Blobs of the photos taken
  var _ref39 = (0, _react.useState)(null),
    _ref40 = _slicedToArray(_ref39, 2),
    forPrint = _ref40[0],
    setForPrint = _ref40[1]; // Blob for printing

  (0, _react.useEffect)(function () {
    function startCamera() {
      return _startCamera.apply(this, arguments);
    }
    function _startCamera() {
      _startCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var stream, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  width: {
                    ideal: 1080
                  },
                  height: {
                    ideal: 1520
                  },
                  facingMode: 'user'
                }
              });
            case 1:
              stream = _context.v;
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                console.log('Givenchy: Video stream set and playing');
              }
              setIsInitialized(true);
              setLoading(false);
              console.log('Givenchy: Camera initialized successfully');
              if (videoRef.current) {
                videoRef.current.srcObject = stream;
                videoRef.current.play();
                console.log('Givenchy: Video stream set and playing (second time)');
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t2 = _context.v;
              setError(_t2);
              setLoading(false);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _startCamera.apply(this, arguments);
    }
    startCamera();
  }, []);

  // Effect pour créer l'image composite quand on a 4 photos
  (0, _react.useEffect)(function () {
    if (photos.length === 4 && step === 3) {
      console.log('Givenchy: 4 photos ready, creating composite image');
      createGif(); // Un seul appel ici
    }
  }, [step, photos]);
  (0, _react.useEffect)(function () {
    handleShare();
  }, [currentDataUri]);
  var createGif2 = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var canvasWidth, canvasHeight, gridWidth, gridHeight, gridX, gridY, spacingX, spacingY, photoWidth, photoHeight, canvas, ctx, background, positions, drawPhotos, finalImageDataUri;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // Dimensions du canvas final
            canvasWidth = 800;
            canvasHeight = 1200; // Zone centrale pour la grille (centrée)
            gridWidth = canvasWidth * 0.8;
            gridHeight = canvasHeight * 0.7;
            gridX = (canvasWidth - gridWidth) / 2;
            gridY = (canvasHeight - gridHeight) / 2; // Espacement relatif (5% de la largeur/hauteur de la zone grille)
            spacingX = gridWidth * 0.05;
            spacingY = gridHeight * 0.05; // Dimensions de chaque photo
            photoWidth = (gridWidth - spacingX) / 2;
            photoHeight = (gridHeight - spacingY) / 2;
            canvas = document.createElement('canvas');
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            ctx = canvas.getContext('2d'); // Charger et dessiner l'image de fond Givenchy
            background = new Image();
            background.crossOrigin = 'anonymous';
            background.src = uriTransformer("https://web-treeosk.online/apks/bg_givenchy.png");
            _context4.n = 1;
            return new Promise(function (resolve) {
              background.onload = function () {
                ctx.drawImage(background, 0, 0, canvasWidth, canvasHeight);
                resolve();
              };
              background.onerror = function () {
                console.error("Erreur de chargement du fond");
                resolve();
              };
            });
          case 1:
            // Positions des 4 photos en grille 2x2, centrée
            positions = [{
              x: gridX,
              y: gridY
            }, {
              x: gridX + photoWidth + spacingX,
              y: gridY
            }, {
              x: gridX,
              y: gridY + photoHeight + spacingY
            }, {
              x: gridX + photoWidth + spacingX,
              y: gridY + photoHeight + spacingY
            }];
            drawPhotos = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var promises, borderRadius, _loop, index;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      promises = [];
                      borderRadius = Math.min(photoWidth, photoHeight) * 0.22; // arrondi fort
                      _loop = /*#__PURE__*/_regenerator().m(function _loop(index) {
                        var pos, promise;
                        return _regenerator().w(function (_context2) {
                          while (1) switch (_context2.n) {
                            case 0:
                              pos = positions[index];
                              if (photos[index]) {
                                promise = new Promise(function (resolve) {
                                  var photoImg = new Image();
                                  photoImg.crossOrigin = 'anonymous';
                                  photoImg.src = photos[index];
                                  photoImg.onload = function () {
                                    // Calculer le crop pour objectFit: 'cover'
                                    var imgAspect = photoImg.width / photoImg.height;
                                    var photoAspect = photoWidth / photoHeight;
                                    var sourceX = 0,
                                      sourceY = 0,
                                      sourceWidth = photoImg.width,
                                      sourceHeight = photoImg.height;
                                    if (imgAspect > photoAspect) {
                                      sourceWidth = photoImg.height * photoAspect;
                                      sourceX = (photoImg.width - sourceWidth) / 2;
                                    } else {
                                      sourceHeight = photoImg.width / photoAspect;
                                      sourceY = (photoImg.height - sourceHeight) / 2;
                                    }
                                    ctx.save();
                                    ctx.beginPath();
                                    if (index === 0) {
                                      ctx.moveTo(pos.x + borderRadius, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + borderRadius);
                                      ctx.arcTo(pos.x, pos.y, pos.x + borderRadius, pos.y, borderRadius);
                                    } else if (index === 1) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth - borderRadius, pos.y);
                                      ctx.arcTo(pos.x + photoWidth, pos.y, pos.x + photoWidth, pos.y + borderRadius, borderRadius);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y);
                                    } else if (index === 2) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x + borderRadius, pos.y + photoHeight);
                                      ctx.arcTo(pos.x, pos.y + photoHeight, pos.x, pos.y + photoHeight - borderRadius, borderRadius);
                                      ctx.lineTo(pos.x, pos.y);
                                    } else if (index === 3) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight - borderRadius);
                                      ctx.arcTo(pos.x + photoWidth, pos.y + photoHeight, pos.x + photoWidth - borderRadius, pos.y + photoHeight, borderRadius);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y);
                                    }
                                    ctx.closePath();
                                    ctx.clip();
                                    ctx.translate(pos.x + photoWidth, pos.y);
                                    ctx.scale(-1, 1);
                                    ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, photoWidth, photoHeight);
                                    ctx.restore();
                                    resolve();
                                  };
                                  photoImg.onerror = function () {
                                    console.error('Erreur de chargement de l\'image:', photos[index]);
                                    resolve();
                                  };
                                });
                                promises.push(promise);
                              } else {
                                ctx.strokeStyle = 'rgba(0,0,0,0)';
                                ctx.lineWidth = 2;
                                ctx.strokeRect(pos.x, pos.y, photoWidth, photoHeight);
                              }
                            case 1:
                              return _context2.a(2);
                          }
                        }, _loop);
                      });
                      index = 0;
                    case 1:
                      if (!(index < Math.min(photos.length, 4))) {
                        _context3.n = 3;
                        break;
                      }
                      return _context3.d(_regeneratorValues(_loop(index)), 2);
                    case 2:
                      index++;
                      _context3.n = 1;
                      break;
                    case 3:
                      _context3.n = 4;
                      return Promise.all(promises);
                    case 4:
                      return _context3.a(2);
                  }
                }, _callee2);
              }));
              return function drawPhotos() {
                return _ref2.apply(this, arguments);
              };
            }();
            _context4.n = 2;
            return drawPhotos();
          case 2:
            finalImageDataUri = canvas.toDataURL('image/png');
            console.log('Image composite créée, taille:', finalImageDataUri.length);
            setForPrint(finalImageDataUri);
            canvas.toBlob(function (blob) {
              setBlops(blob);
              console.log('Blob créé pour le partage');
            }, 'image/png');
            handleShare();
          case 3:
            return _context4.a(2);
        }
      }, _callee3);
    }));
    return function createGif2() {
      return _ref.apply(this, arguments);
    };
  }();
  var createGif = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var canvasWidth, canvasHeight, gridWidth, gridHeight, gridX, gridY, spacingX, spacingY, photoWidth, photoHeight, canvas, ctx, positions, drawPhotos, finalImageDataUri;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            _context7.n = 1;
            return createGif2();
          case 1:
            // Dimensions du canvas final
            canvasWidth = 800;
            canvasHeight = 1200; // Zone centrale pour la grille (centrée)
            gridWidth = canvasWidth * 0.8;
            gridHeight = canvasHeight * 0.7;
            gridX = (canvasWidth - gridWidth) / 2;
            gridY = (canvasHeight - gridHeight) / 2; // Espacement relatif (5% de la largeur/hauteur de la zone grille)
            spacingX = gridWidth * 0.05;
            spacingY = gridHeight * 0.05; // Dimensions de chaque photo
            photoWidth = (gridWidth - spacingX) / 2;
            photoHeight = (gridHeight - spacingY) / 2;
            canvas = document.createElement('canvas');
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            ctx = canvas.getContext('2d'); // Fond transparent
            ctx.clearRect(0, 0, canvasWidth, canvasHeight);

            // Positions des 4 photos en grille 2x2, centrée
            positions = [{
              x: gridX,
              y: gridY
            }, {
              x: gridX + photoWidth + spacingX,
              y: gridY
            }, {
              x: gridX,
              y: gridY + photoHeight + spacingY
            }, {
              x: gridX + photoWidth + spacingX,
              y: gridY + photoHeight + spacingY
            }];
            drawPhotos = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
                var promises, borderRadius, _loop2, index;
                return _regenerator().w(function (_context6) {
                  while (1) switch (_context6.n) {
                    case 0:
                      promises = [];
                      borderRadius = Math.min(photoWidth, photoHeight) * 0.22; // arrondi fort
                      _loop2 = /*#__PURE__*/_regenerator().m(function _loop2(index) {
                        var pos, promise;
                        return _regenerator().w(function (_context5) {
                          while (1) switch (_context5.n) {
                            case 0:
                              pos = positions[index];
                              if (photos[index]) {
                                promise = new Promise(function (resolve) {
                                  var photoImg = new Image();
                                  photoImg.crossOrigin = 'anonymous';
                                  photoImg.src = photos[index];
                                  photoImg.onload = function () {
                                    // Calculer le crop pour objectFit: 'cover'
                                    var imgAspect = photoImg.width / photoImg.height;
                                    var photoAspect = photoWidth / photoHeight;
                                    var sourceX = 0,
                                      sourceY = 0,
                                      sourceWidth = photoImg.width,
                                      sourceHeight = photoImg.height;
                                    if (imgAspect > photoAspect) {
                                      sourceWidth = photoImg.height * photoAspect;
                                      sourceX = (photoImg.width - sourceWidth) / 2;
                                    } else {
                                      sourceHeight = photoImg.width / photoAspect;
                                      sourceY = (photoImg.height - sourceHeight) / 2;
                                    }
                                    ctx.save();
                                    ctx.beginPath();
                                    if (index === 0) {
                                      ctx.moveTo(pos.x + borderRadius, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + borderRadius);
                                      ctx.arcTo(pos.x, pos.y, pos.x + borderRadius, pos.y, borderRadius);
                                    } else if (index === 1) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth - borderRadius, pos.y);
                                      ctx.arcTo(pos.x + photoWidth, pos.y, pos.x + photoWidth, pos.y + borderRadius, borderRadius);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y);
                                    } else if (index === 2) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight);
                                      ctx.lineTo(pos.x + borderRadius, pos.y + photoHeight);
                                      ctx.arcTo(pos.x, pos.y + photoHeight, pos.x, pos.y + photoHeight - borderRadius, borderRadius);
                                      ctx.lineTo(pos.x, pos.y);
                                    } else if (index === 3) {
                                      ctx.moveTo(pos.x, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y);
                                      ctx.lineTo(pos.x + photoWidth, pos.y + photoHeight - borderRadius);
                                      ctx.arcTo(pos.x + photoWidth, pos.y + photoHeight, pos.x + photoWidth - borderRadius, pos.y + photoHeight, borderRadius);
                                      ctx.lineTo(pos.x, pos.y + photoHeight);
                                      ctx.lineTo(pos.x, pos.y);
                                    }
                                    ctx.closePath();
                                    ctx.clip();
                                    ctx.translate(pos.x + photoWidth, pos.y);
                                    ctx.scale(-1, 1);
                                    ctx.drawImage(photoImg, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, photoWidth, photoHeight);
                                    ctx.restore();
                                    resolve();
                                  };
                                  photoImg.onerror = function () {
                                    console.error('Erreur de chargement de l\'image:', photos[index]);
                                    resolve();
                                  };
                                });
                                promises.push(promise);
                              } else {
                                ctx.strokeStyle = 'rgba(0,0,0,0)';
                                ctx.lineWidth = 2;
                                ctx.strokeRect(pos.x, pos.y, photoWidth, photoHeight);
                              }
                            case 1:
                              return _context5.a(2);
                          }
                        }, _loop2);
                      });
                      index = 0;
                    case 1:
                      if (!(index < Math.min(photos.length, 4))) {
                        _context6.n = 3;
                        break;
                      }
                      return _context6.d(_regeneratorValues(_loop2(index)), 2);
                    case 2:
                      index++;
                      _context6.n = 1;
                      break;
                    case 3:
                      _context6.n = 4;
                      return Promise.all(promises);
                    case 4:
                      return _context6.a(2);
                  }
                }, _callee4);
              }));
              return function drawPhotos() {
                return _ref4.apply(this, arguments);
              };
            }();
            _context7.n = 2;
            return drawPhotos();
          case 2:
            finalImageDataUri = canvas.toDataURL('image/png');
            console.log('Image composite créée, taille:', finalImageDataUri.length);
            setCurrentDataUri(finalImageDataUri);
            canvas.toBlob(function (blob) {
              setBlops(blob);
              console.log('Blob créé pour le partage');
            }, 'image/png');
            handleShare();
          case 3:
            return _context7.a(2);
        }
      }, _callee5);
    }));
    return function createGif() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var response, record, _t3;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            if (forPrint) {
              _context8.n = 1;
              break;
            }
            console.error('Aucune image à partager');
            return _context8.a(2);
          case 1:
            _context8.p = 1;
            setIsSending(true);

            // Envoyer directement l'image composite (grille de 4 photos)
            _context8.n = 2;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: forPrint,
                // Utiliser l'image composite
                email: null // Pas d'email pour Givenchy
              })
            });
          case 2:
            response = _context8.v;
            if (response.ok) {
              _context8.n = 3;
              break;
            }
            throw new Error('Upload failed');
          case 3:
            _context8.n = 4;
            return response.json();
          case 4:
            record = _context8.v;
            setLink(record.image_uri);
            logEvent('click', {
              cellId: cell.id,
              pageId: page.id,
              languageCode: intl.locale,
              action: 'send_photo',
              email: null,
              // Pas d'email pour Givenchy
              link: record.image_uri
            });
            console.log('Photo grille Givenchy partagée avec succès');
            _context8.n = 6;
            break;
          case 5:
            _context8.p = 5;
            _t3 = _context8.v;
            console.error('Error sending photo:', _t3);
          case 6:
            _context8.p = 6;
            setIsSending(false);
            console.log('Photo sent successfully');
            return _context8.f(6);
          case 7:
            return _context8.a(2);
        }
      }, _callee6, null, [[1, 5, 6, 7]]);
    }));
    return function handleShare() {
      return _ref5.apply(this, arguments);
    };
  }();
  function handlePrintCall() {
    return _handlePrintCall.apply(this, arguments);
  }
  function _handlePrintCall() {
    _handlePrintCall = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.n) {
          case 0:
            if (!printed) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2);
          case 1:
            _context9.n = 2;
            return createGif();
          case 2:
            try {
              // Imprimer directement l'image composite (grille de 4 photos)
              if (window.electronAPI) {
                window.electronAPI.sendImageForPrint(forPrint);
              }
              if (window.Android && typeof window.Android.postMessage === 'function') {
                window.Android.postMessage(forPrint);
              }
              setPrinted(true);
              console.log('Image grille Givenchy envoyée pour impression:', forPrint);
            } catch (error) {
              console.log('Error');
            }
          case 3:
            return _context9.a(2);
        }
      }, _callee7);
    }));
    return _handlePrintCall.apply(this, arguments);
  }
  function capturePhotoSequence() {
    console.log('Givenchy: capturePhotoSequence started, started state:', started);
    if (started) {
      console.log('Givenchy: Already started, returning');
      return; // Prevent multiple captures
    }
    console.log('Givenchy: Setting started to true');
    setStarted(true);
    var totalPhotos = 4; // 4 photos pour Givenchy
    var countdownTime = 4;
    setStep(1);
    setPhotos([]); // reset existing photos

    var currentPhoto = 0;
    function countdownAndCapture() {
      var currentCount = countdownTime;
      var countdownInterval = setInterval(function () {
        setCount(currentCount - 1);
        --currentCount;
        if (currentCount <= 0) {
          clearInterval(countdownInterval);
          captureOnePhoto(function (photo) {
            console.log('Givenchy: Photo captured:', currentPhoto + 1, 'Total photos:', photos.length + 1);
            setPhotos(function (prev) {
              var newPhotos = [].concat(_toConsumableArray(prev), [photo]);
              console.log('Givenchy: Updated photos array:', newPhotos.length);
              return newPhotos;
            });
            currentPhoto++;
            if (currentPhoto < totalPhotos) {
              countdownAndCapture();
            } else {
              console.log('Givenchy: All photos captured, moving to step 3');
              setStep(3);
              // Ne pas appeler createGif() ici car l'état photos n'est pas encore mis à jour
            }
          });
        }
      }, 1000);
    }
    countdownAndCapture();
  }
  function captureOnePhoto(callback) {
    console.log('Givenchy: captureOnePhoto called');
    var video = videoRef.current;
    if (!video) {
      console.error('Givenchy: No video element found');
      return;
    }
    var canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    for (var i = 0; i < data.length; i += 4) {
      var avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
      data[i] = data[i + 1] = data[i + 2] = avg;
    }
    ctx.putImageData(imageData, 0, 0);
    var photoDataUrl = canvas.toDataURL('image/png');
    console.log('Givenchy: Photo data URL created, length:', photoDataUrl.length);
    callback(photoDataUrl);
  }
  if (!isInitialized && loading) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : 'arial',
        color: cell.text_color,
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '60%',
        margin: 'auto',
        height: '60%',
        fontSize: '3em',
        textAlign: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement("span", null, "Initialisation de la cam\xE9ra..."), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(LoadingSvg, {
      cell: cell,
      animated: true
    })));
  }
  if (error) {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        fontFamily: project ? project.default_button_font : 'arial',
        color: 'red',
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '80%',
        margin: 'auto',
        height: '80%',
        fontSize: '2em',
        textAlign: 'center'
      }
    }, "Erreur d'acc\xE8s \xE0 la cam\xE9ra : ", error.message));
  }
  switch (step) {
    case 0:
    case 1:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        style: {
          display: 'none'
        },
        autoPlay: true,
        muted: true,
        playsInline: true
      }), !isInitialized && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          fontSize: '1em',
          textAlign: 'center',
          zIndex: 4
        }
      }, "Initialisation de la cam\xE9ra..."), step === 1 && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: '20%',
          left: '50%',
          transform: 'translateX(-50%)',
          color: 'white',
          fontSize: '1.6em',
          fontWeight: 'bold',
          textAlign: 'center',
          zIndex: 4,
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          letterSpacing: '1px'
        }
      }, "Photo ", photos.length + 1, " sur 4"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '85%',
          height: '55%',
          background: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(15px)',
          borderRadius: '25px',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          marginTop: '-34%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("video", {
        ref: videoRef,
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '25px',
          zIndex: -1,
          transform: 'scaleX(-1)'
        },
        autoPlay: true,
        muted: true,
        playsInline: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '25px',
          zIndex: 0
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
          zIndex: 1,
          position: 'relative'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: function onClick() {
          console.log('Givenchy: Preview clicked, isInitialized:', isInitialized, 'started:', started);
          if (isInitialized && !started) {
            capturePhotoSequence();
          }
        },
        style: {
          width: '180px',
          height: '180px',
          borderRadius: '50%',
          background: 'rgba(255, 255, 255, 0.1)',
          border: '2px solid rgba(255, 255, 255, 0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '4em',
          fontWeight: 'bold',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          cursor: isInitialized && !started ? 'pointer' : 'default',
          backdropFilter: 'blur(10px)'
        }
      }, step === 1 ? /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '2em',
          fontWeight: 'bold',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)'
        }
      }, count) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '60px',
          height: '60px',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "white",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        style: {
          filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
        }
      }, /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        cx: "12",
        cy: "13",
        r: "3"
      })))), !started && /*#__PURE__*/_react.default.createElement("span", {
        style: {
          fontSize: '1.1em',
          fontWeight: 'bold',
          textAlign: 'center',
          letterSpacing: '1px',
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          color: 'white',
          textTransform: 'uppercase'
        }
      }, "TAKE THE PHOTO"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          bottom: '14%',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'nowrap',
          zIndex: 3
        }
      }, [0, 1, 2, 3].map(function (index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index,
          style: {
            width: '200px',
            height: '320px',
            borderRadius: '12px',
            background: photos[index] ? 'white' : index === 0 ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
            backgroundSize: 'cover',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.6em',
            fontWeight: 'bold',
            color: photos[index] ? '#333' : index === 0 ? '#333' : 'white',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            textShadow: photos[index] ? 'none' : index === 0 ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.5)',
            flexShrink: 0,
            backdropFilter: 'blur(5px)'
          }
        }, photos[index] ? /*#__PURE__*/_react.default.createElement("img", {
          src: photos[index],
          alt: "Photo ".concat(index + 1),
          style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '10px',
            transform: 'scaleX(-1)'
          }
        }) : /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontSize: '1.6em',
            fontWeight: 'bold',
            textShadow: index === 0 ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.5)'
          }
        }, index + 1));
      })));
    case 2:
      console.log('Givenchy: Rendering case 2, photos available:', photos.length, photos);
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("style", null, "\n                            .selectable:hover {\n                                cursor: pointer;\n                                opacity: 0.8;\n                                scale: 1.05;\n                                transform-origin: center;\n                            }\n                        "), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          height: '64%',
          border: 'solid 0.5em ' + cell.border_color
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: photos[currentPhoto.index] || photos[0],
        alt: "Photo ".concat(currentPhoto.index + 1),
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          transform: 'scaleX(-1)',
          opacity: isSelected ? 1 : 0.4
        }
      }), !isSelected && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          left: 0,
          textAlign: 'center',
          fontSize: '2em',
          position: 'absolute',
          width: '100%',
          top: '58%',
          color: 'white',
          display: 'flex'
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          margin: 'auto',
          textAlign: 'center'
        }
      }, "choisis ta photo"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          height: '18%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          gap: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[0] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 0
          });
          setIsSelected(true);
        },
        src: photos[0],
        alt: "Photo 1",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 0 ? 1 : 0.6,
          cursor: 'pointer',
          transform: 'scaleX(-1)',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "1"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[1] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 1
          });
          setIsSelected(true);
        },
        src: photos[1],
        alt: "Photo 2",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 1 ? 1 : 0.6,
          cursor: 'pointer',
          transform: 'scaleX(-1)',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "2"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[2] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 2
          });
          setIsSelected(true);
        },
        src: photos[2],
        alt: "Photo 3",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 2 ? 1 : 0.6,
          cursor: 'pointer',
          transform: 'scaleX(-1)',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "3"))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          height: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '100%'
        }
      }, photos[3] ? /*#__PURE__*/_react.default.createElement("img", {
        className: "selectable",
        onClick: function onClick() {
          setCurrentPhoto({
            index: 3
          });
          setIsSelected(true);
        },
        src: photos[3],
        alt: "Photo 4",
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          border: 'solid 0.5em ' + cell.border_color,
          opacity: currentPhoto.index === 3 ? 1 : 0.6,
          cursor: 'pointer',
          transform: 'scaleX(-1)',
          background: 'rgba(255,255,255,1)'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.2em'
        }
      }, "4")))), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '80%',
          margin: 'auto',
          display: 'flex',
          flexDirection: 'row'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                setStarted(false);
                setStep(0);
                setPhotos([]);
                setCurrentPhoto({
                  index: 0
                });
                setIsSelected(false);
              case 1:
                return _context0.a(2);
            }
          }, _callee8);
        })),
        style: {
          width: '100%',
          margin: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          background: 'rgba(255,255,255,0.4)',
          padding: '1em',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'white',
          fontSize: '1.2em',
          marginLeft: '1em'
        }
      }, "Recommencer")), isSelected && /*#__PURE__*/_react.default.createElement("div", {
        onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                setStep(3);
                createGif();
              case 1:
                return _context1.a(2);
            }
          }, _callee9);
        })),
        style: {
          width: '100%',
          margin: 'auto',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '2em',
          background: 'white',
          padding: '1em',
          flex: 1
        }
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          color: 'black',
          fontSize: '1.2em',
          marginLeft: '1em'
        }
      }, "Continuer"))));
    case 3:
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          fontFamily: project ? project.default_button_font : 'arial',
          color: cell.text_color,
          width: '100%',
          height: '100%',
          position: 'relative',
          overflow: 'hidden'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-container",
        style: {
          width: '100%',
          margin: '0 auto',
          height: '80%',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, currentDataUri ? /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          left: '0%',
          top: '0%',
          width: '100%',
          height: '100%',
          backgroundImage: "url(".concat(currentDataUri, ")"),
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          borderRadius: '80px',
          overflow: 'hidden'
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement(LoadingSvg, {
        cell: cell,
        animated: true
      }))), currentDataUri && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'absolute',
          backdropFilter: 'blur(10px)',
          padding: '0.4em',
          background: 'rgba(255,255,255,0.3)',
          width: '80%',
          margin: 'auto',
          height: '14%',
          display: 'flex',
          marginTop: '2em',
          gap: '1em',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '1.2em',
          bottom: '12%',
          left: '10%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          marginTop: '2.5em'
        }
      }, /*#__PURE__*/_react.default.createElement("h1", {
        style: {
          textAlign: 'center',
          color: 'white'
        }
      }, "Imprimer la photo ou scanner le QR code"), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'row',
          padding: '1em',
          alignItems: 'center',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1em'
        }
      }, /*#__PURE__*/_react.default.createElement("button", {
        disabled: printed,
        style: {
          background: 'black',
          color: 'white',
          border: 'none',
          padding: '1em 2em',
          cursor: 'pointer',
          fontSize: '1em',
          fontWeight: 'bold',
          opacity: printed ? 0.6 : 1,
          borderRadius: '8px'
        },
        onClick: handlePrintCall
      }, printed ? 'Imprimé' : 'Imprimer la Photo')), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          flex: 1,
          display: 'flex',
          justifyContent: 'center'
        }
      }, link && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          color: 'white',
          fontSize: '0.9em',
          marginBottom: '0.5em',
          fontWeight: 'bold'
        }
      }, "Scanner le QR code"), /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
        value: link,
        size: 100
      })))))));
    default:
      return null;
  }
}
function LoadingSvg(_ref41) {
  var cell = _ref41.cell,
    animated = _ref41.animated;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "100",
    height: "100",
    viewBox: "0 0 50 50",
    style: {
      animation: animated ? 'spin 1s linear infinite' : 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n                    @keyframes spin {\n                        0% { transform: rotate(0deg); }\n                        100% { transform: rotate(360deg); }\n                    }\n                "), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    stroke: cell.text_color,
    strokeWidth: "5",
    strokeDasharray: "31.416",
    strokeDashoffset: "31.416"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "stroke-dasharray",
    dur: "2s",
    values: "0 31.416;15.708 15.708;0 31.416",
    repeatCount: "indefinite"
  })));
}